import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6 p-6" }
const _hoisted_2 = { class: "flex justify-end items-center" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-4 gap-4" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_7 = { class: "w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "text-3xl font-bold text-green-600 mt-2" }
const _hoisted_10 = { class: "w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_13 = { class: "w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center" }
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "text-3xl font-bold text-orange-600 mt-2" }
const _hoisted_16 = { class: "w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center" }
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = { class: "flex flex-wrap gap-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "overflow-x-auto" }
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = { class: "divide-y divide-gray-200" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "px-4 py-4" }
const _hoisted_28 = { class: "flex items-center gap-3" }
const _hoisted_29 = { class: "w-10 h-10 rounded-full bg-gradient-to-br from-sky-700 to-sky-900 flex items-center justify-center text-white font-semibold text-sm" }
const _hoisted_30 = { class: "font-medium text-gray-900" }
const _hoisted_31 = { class: "text-sm text-gray-600" }
const _hoisted_32 = { class: "px-6 py-4" }
const _hoisted_33 = { class: "font-mono text-sm font-medium text-gray-900" }
const _hoisted_34 = { class: "text-sm text-gray-600" }
const _hoisted_35 = { class: "px-6 py-4" }
const _hoisted_36 = { class: "font-medium text-gray-900" }
const _hoisted_37 = { class: "px-6 py-4" }
const _hoisted_38 = { class: "font-medium text-gray-900" }
const _hoisted_39 = { class: "text-sm text-gray-600" }
const _hoisted_40 = { class: "px-6 py-4" }
const _hoisted_41 = { class: "text-sm text-gray-900" }
const _hoisted_42 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_43 = { class: "px-6 py-4" }
const _hoisted_44 = { class: "flex items-center gap-2" }
const _hoisted_45 = { class: "text-sm font-medium" }
const _hoisted_46 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_47 = {
  key: 0,
  class: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4"
}
const _hoisted_48 = { class: "text-sm text-gray-700" }
const _hoisted_49 = { class: "font-medium" }
const _hoisted_50 = { class: "font-medium" }
const _hoisted_51 = { class: "font-medium" }
const _hoisted_52 = { class: "text-green-600 font-medium ml-2" }
const _hoisted_53 = { class: "flex items-center gap-2" }
const _hoisted_54 = { class: "flex items-center justify-between" }
const _hoisted_55 = { class: "flex items-center gap-3" }
const _hoisted_56 = { class: "text-sm text-green-700" }

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import {
  useFetchMedicalSchemeHealthSeekers
} from '@/hooks/use-health-insurances';
import {
  useFetchPerSchemeTariffCodesRates
} from '@/hooks/use-tariff-codes';
import {
  useSyncPracticeTypes
} from '@/hooks/use-treatment-plans';
import {
  useMedicalSchemesStore
} from '@/store/use-medical-schemes-store';
import { useRolloverStore } from '@/store/use-rollover-store';
import {
  useTariffCodeStore
} from '@/store/use-tariff-codes-store';
import { showSuccess } from '@/utils/toast';
import {
  parseHealthSeekerData,
  parseTariffCodeData,
  prepareDataForSync
} from '@/utils/utils';
import PreviewResultsDialog from '@/views/tools/previews/PreviewResultsDialog.vue';
import {
  AlertCircle, ArrowLeft, CheckCircle2,
  FileText,
  RefreshCw,
  Search,
  UserCheck,
  Users
} from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from 'vue-sonner';


export default /*@__PURE__*/_defineComponent({
  __name: 'SyncPracticesView',
  props: {
    members: {},
    tariffRates: {}
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

// Get store
const tariffCodesStore = useTariffCodeStore();
const medicalSchemeStore = useMedicalSchemesStore();
const rolloverStore = useRolloverStore()

const { mutate: syncPracticeTypes, isPending } = useSyncPracticeTypes()

// Destructure state with storeToRefs
const { medicalScheme } = storeToRefs(medicalSchemeStore)
// Note [Re-used Rollover Store] : Destructure state with storeToRefs
const { rolloverResults } = storeToRefs(rolloverStore)

// Props (would normally come from API)
const props = __props;

const emit = __emit

// State
const searchQuery = ref('');
const selectedTariffCodes = ref<string[]>([]);
const selectedMembers = ref<string[]>([]);
const isSyncing = ref(false);
const isResultDialogOpen = ref(false)

// Pagination
const currentPage = ref(1);
const itemsPerPage = ref(15);

// Fetch clients data
const {
  data: fetchedMembers,
} = useFetchMedicalSchemeHealthSeekers(medicalScheme.value?.funder_id)

// Fetch tariff codes based on applicable year
const {
  data: fetchedRTariffRates,
} = useFetchPerSchemeTariffCodesRates(tariffCodesStore.getApplicableYear, medicalScheme.value?.funder_id)

// Use computed to reactively access the data
const members = computed(() => fetchedMembers.value || [])

const hasResults = computed(() => rolloverResults.value !== null)

// Use computed to reactively access the data
const tariffRates = computed(() => fetchedRTariffRates.value || [])

// Computed
const filteredMembers = computed(() => {
  if (!searchQuery.value) return members.value;
  
  const query = searchQuery.value.toLowerCase();
  return members.value.filter((item: any) =>
    item.client.first_name.toLowerCase().includes(query) ||
    item.client.last_name.toLowerCase().includes(query) ||
    item.membership_number.includes(query) ||
    item.client.email?.toLowerCase().includes(query) ||
    item.client.id_number?.includes(query)
  );
});

// Pagination
const totalPages = computed(() => {
  return Math.ceil(filteredMembers.value.length / itemsPerPage.value);
});

const startIndex = computed(() => {
  return (currentPage.value - 1) * itemsPerPage.value;
});

const endIndex = computed(() => {
  return startIndex.value + itemsPerPage.value;
});

const paginatedMembers = computed(() => {
  return filteredMembers.value.slice(startIndex.value, endIndex.value);
});

const displayPages = computed(() => {
  const pages = [];
  const maxPagesToShow = 5;
  let startPage = Math.max(1, currentPage.value - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages.value, startPage + maxPagesToShow - 1);

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
});

const stats = computed(() => ({
  totalMembers: members.value.length,
  selectedMembers: selectedMembers.value.length,
  totalTariffs: tariffRates.value.length,
  selectedTariffs: selectedTariffCodes.value.length
}));

// Check if all members on CURRENT PAGE are selected
const allPageMembersSelected = computed(() => {
  if (paginatedMembers.value.length === 0) return false;
  return paginatedMembers.value.every((m: any) => 
    selectedMembers.value.includes(getMemberKey(m))
  );
});

const allTariffsSelected = computed(() => {
  return tariffRates.value.length > 0 && selectedTariffCodes.value.length === tariffRates.value.length;
});

const canSync = computed(() => {
  return selectedTariffCodes.value.length > 0 && selectedMembers.value.length > 0;
});

// Methods
const toggleTariffCode = (tariffCode: any) => {
  console.log('Selected-Tariff-Code: ', tariffCode);
  const rateId = tariffCode?.rate_id
  const parsedTariffCode = parseTariffCodeData(tariffCode)
  console.log(`Parsed-Tariff-Code:`, JSON.stringify(parsedTariffCode));
  const index = selectedTariffCodes.value.indexOf(rateId);
  if (index > -1) {
    selectedTariffCodes.value.splice(index, 1);
    // TODO: Remove from store
    tariffCodesStore.removeTariffCodeFromTariffCodesList(parsedTariffCode?.code)
  } else {
    selectedTariffCodes.value.push(rateId);
    tariffCodesStore.addTariffCodeToTariffCodeList(parsedTariffCode)
  }
  // TODO: SET STORE
  console.log(`Selected Codes Count: `, tariffCodesStore.tariffCodesCount);
};

const toggleMember = (member: any) => {
  const memberKey = getMemberKey(member);
  const parsedMember = parseHealthSeekerData(member);
  console.log(`Parsed-Member:`, JSON.stringify(parsedMember));
  const index = selectedMembers.value.indexOf(memberKey);
  if (index > -1) {
    selectedMembers.value.splice(index, 1);
    // TODO: Separate Members Store from Tariff Code Store
    tariffCodesStore.removeMemberFromMembersList(parsedMember.membership_number);
  } else {
    selectedMembers.value.push(getMemberKey(member));
    tariffCodesStore.addMemberToMembersList(parsedMember);
  }
  console.log(tariffCodesStore.membersCount);
};

// Updated to only select/deselect current page members
const toggleAllPageMembers = () => {
  if (allPageMembersSelected.value) {
    // Deselect all members on current page
    paginatedMembers.value.forEach((member: any) => {
      const memberKey = getMemberKey(member);
      const index = selectedMembers.value.indexOf(memberKey);
      if (index > -1) {
        selectedMembers.value.splice(index, 1);
        const parsedMember = parseHealthSeekerData(member);
        tariffCodesStore.removeMemberFromMembersList(parsedMember.membership_number);
      }
    });
  } else {
    // Select all members on current page
    paginatedMembers.value.forEach((member: any) => {
      const memberKey = getMemberKey(member);
      if (!selectedMembers.value.includes(memberKey)) {
        selectedMembers.value.push(memberKey);
        const parsedMember = parseHealthSeekerData(member);
        tariffCodesStore.addMemberToMembersList(parsedMember);
      }
    });
  }
};

const toggleAllTariffs = () => {
  if (allTariffsSelected.value) {
    selectedTariffCodes.value = [];
    // Store Clear TariffCodes List
    tariffCodesStore.clearTariffCodesList()
  } else {
    selectedTariffCodes.value = tariffRates.value.map(t => t.rate_id);
    const parsedTariffCodesList = tariffRates.value.map(t => parseTariffCodeData(t));
    console.log(`Parsed-Tariff-Codes: `, JSON.stringify(parsedTariffCodesList));
    tariffCodesStore.addTariffCodes(parsedTariffCodesList);
  }
  console.log(`Tariff-Codes-Count: `, tariffCodesStore.tariffCodesCount);
};

const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const getMemberKey = (member: any) => {
  return `${member.membership_number}-${member.dependant_key}`;
};

const isMemberSelected = (member: any) => {
  return selectedMembers.value.includes(getMemberKey(member));
};

const isTariffSelected = (rateId: string) => {
  return selectedTariffCodes.value.includes(rateId);
};

const getInitials = (client: any) => {
  const first = client.first_name?.[0] || '';
  const last = client.last_name?.[0] || '';
  return `${first}${last}`.toUpperCase();
};

// Get status color
const getStatusColor = (isActive: boolean) => {
  return isActive ? 'bg-green-500' : 'bg-red-500'
}

const getPhaseName = (phase: string) => {
  const phases: Record<string, string> = {
    'SO': 'Standard Ongoing',
    'SI': 'Standard Intensive',
    'RO': 'Remote Ongoing',
    'RI': 'Remote Intensive'
  };
  return phases[phase] || phase;
};

const getPhaseClass = (phase: string) => {
  const classes: Record<string, string> = {
    'SO': 'bg-green-100 text-green-800',
    'SI': 'bg-yellow-100 text-yellow-800',
    'RO': 'bg-blue-100 text-blue-800',
    'RI': 'bg-purple-100 text-purple-800'
  };
  return classes[phase] || 'bg-gray-100 text-gray-800';
};

const handleSync = async () => {
  if (!canSync.value) {
    toast.error('Please select at least one tariff code and one member');
    return;
  }

  const syncPayload = prepareDataForSync(tariffCodesStore.membersList, tariffCodesStore.tariffCodesList);
  
  const payload = JSON.stringify(syncPayload)
  console.log(`Sync-Payload: `, JSON.stringify(syncPayload));
  isSyncing.value = true;
  
  syncPracticeTypes({ payload: payload }, {
    onSuccess: (data) => {
      showSuccess("Practice Types Syncing completed!");
      rolloverStore.setRolloverResults(data)
      isResultDialogOpen.value = true
      // Reset Selctions
      isSyncing.value = false;
      tariffCodesStore.clearAllLists();
      selectedTariffCodes.value = [];
      selectedMembers.value = [];
    },
    onError: (error: any) => {
      console.log(error.message);
      // showError(error.message || 'An error occurred during syncing');
      isSyncing.value = false;
      // Reset Selctions
      isSyncing.value = false;
      tariffCodesStore.clearAllLists();
      selectedTariffCodes.value = [];
      selectedMembers.value = [];
    }
  })
};

if (hasResults) {
  isResultDialogOpen.value = true
}

const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
  }).format(amount);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
        class: "flex items-center border border-gray-300 bg-gray-200 hover:bg-sky-700 hover:text-white"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowLeft)),
          _cache[3] || (_cache[3] = _createTextVNode(" Back ", -1))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("h1", { class: "text-3xl font-bold text-gray-900" }, "Sync Practice Types"),
        _createElementVNode("p", { class: "text-gray-600 mt-1" }, "Select tariff codes and members to sync practice types")
      ], -1)),
      _createVNode(_unref(Button), {
        onClick: handleSync,
        disabled: !canSync.value || isSyncing.value,
        size: "lg",
        class: "gap-2 border border-sky-700"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(RefreshCw), {
            class: _normalizeClass(['h-5 w-5', { 'animate-spin': isSyncing.value }])
          }, null, 8, ["class"]),
          _createTextVNode(" " + _toDisplayString(isSyncing.value ? 'Syncing...' : 'Sync Practice Types'), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Card), null, {
        default: _withCtx(() => [
          _createVNode(_unref(CardContent), { class: "pt-6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Total Members", -1)),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(stats.value.totalMembers), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(Users), { class: "h-6 w-6 text-blue-600" })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Card), null, {
        default: _withCtx(() => [
          _createVNode(_unref(CardContent), { class: "pt-6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Selected Members", -1)),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(stats.value.selectedMembers), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(UserCheck), { class: "h-6 w-6 text-green-600" })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Card), null, {
        default: _withCtx(() => [
          _createVNode(_unref(CardContent), { class: "pt-6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Total Tariffs", -1)),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(stats.value.totalTariffs), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(FileText), { class: "h-6 w-6 text-purple-600" })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Card), null, {
        default: _withCtx(() => [
          _createVNode(_unref(CardContent), { class: "pt-6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Selected Tariffs", -1)),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(stats.value.selectedTariffs), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(CheckCircle2), { class: "h-6 w-6 text-orange-600" })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Card), null, {
      default: _withCtx(() => [
        _createVNode(_unref(CardHeader), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Tariff Codes", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(CardDescription), null, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Select the tariff codes to sync practice types", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createVNode(_unref(Button), {
                onClick: toggleAllTariffs,
                variant: "outline",
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(allTariffsSelected.value ? 'Deselect All' : 'Select All'), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(CardContent), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tariffRates.value, (rate) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: rate.rate_id,
                  onClick: ($event: any) => (toggleTariffCode(rate)),
                  class: _normalizeClass([
              'cursor-pointer transition-all p-1 rounded-lg border',
              isTariffSelected(rate.rate_id)
                ? 'border-green-500 bg-green-100'
                : 'border-gray-100 hover:border-green-500 bg-white'
            ])
                }, [
                  _createVNode(_unref(Badge), {
                    variant: "outline",
                    class: "font-mono rounded-md"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(rate.tariff_code.code), 1)
                    ]),
                    _: 2
                  }, 1024)
                ], 10, _hoisted_19))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Card), null, {
      default: _withCtx(() => [
        _createVNode(_unref(CardHeader), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Members", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(CardDescription), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Select the members to apply practice types (Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(totalPages.value) + ")", 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" }),
                  _createVNode(_unref(Input), {
                    modelValue: searchQuery.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                    placeholder: "Search members...",
                    class: "pl-9 w-64"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_unref(Button), {
                  onClick: toggleAllPageMembers,
                  variant: "outline",
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(allPageMembersSelected.value ? 'Deselect All' : 'Select All'), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(CardContent), { class: "p-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("table", _hoisted_24, [
                _cache[12] || (_cache[12] = _createElementVNode("thead", { class: "bg-gray-50 border-b" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Member"),
                    _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Membership"),
                    _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Funder"),
                    _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Option"),
                    _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Date Enrolled"),
                    _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Status")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedMembers.value, (member) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: getMemberKey(member),
                      onClick: ($event: any) => (toggleMember(member)),
                      class: _normalizeClass([
                  'cursor-pointer transition-colors',
                  isMemberSelected(member)
                    ? 'bg-green-400/10 hover:bg-green-400/20'
                    : 'hover:bg-gray-50'
                ])
                    }, [
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(getInitials(member.client)), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_30, _toDisplayString(member.client.first_name) + " " + _toDisplayString(member.client.last_name), 1),
                            _createElementVNode("div", _hoisted_31, " ID: " + _toDisplayString(member.client.id_number || member.client.passport_number || '-'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(member.membership_number), 1),
                          _createElementVNode("div", _hoisted_34, "Dep: " + _toDisplayString(member.dependant_key), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_35, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_36, _toDisplayString(member.funder.funder.name), 1),
                          _createVNode(_unref(Badge), {
                            variant: "outline",
                            class: "font-mono text-xs mt-1 py-0 border rounded-full border-yellow-700"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(member.funder.funder.scheme_code), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_37, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_38, _toDisplayString(member.funder.code), 1),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(member.funder.name), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(member.date_enrolled), 1),
                        (member.date_joined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Joined: " + _toDisplayString(member.date_joined), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", {
                            class: _normalizeClass(['w-2 h-2 rounded-full', getStatusColor(member.is_active)])
                          }, null, 2),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(member.is_active ? 'Active' : 'Inactive'), 1)
                        ])
                      ])
                    ], 10, _hoisted_26))
                  }), 128))
                ])
              ]),
              (paginatedMembers.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createVNode(_unref(AlertCircle), { class: "h-16 w-16 mx-auto text-gray-400 mb-4" }),
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-gray-600 text-lg font-medium" }, "No members found", -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-gray-500 text-sm mt-1" }, "Try adjusting your search", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (filteredMembers.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _cache[15] || (_cache[15] = _createTextVNode(" Showing ", -1)),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(startIndex.value + 1), 1),
                    _cache[16] || (_cache[16] = _createTextVNode(" to ", -1)),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(Math.min(endIndex.value, filteredMembers.value.length)), 1),
                    _cache[17] || (_cache[17] = _createTextVNode(" of ", -1)),
                    _createElementVNode("span", _hoisted_51, _toDisplayString(filteredMembers.value.length), 1),
                    _cache[18] || (_cache[18] = _createTextVNode(" results ", -1)),
                    _createElementVNode("span", _hoisted_52, "(" + _toDisplayString(stats.value.selectedMembers) + " selected)", 1)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_unref(Button), {
                      onClick: previousPage,
                      disabled: currentPage.value === 1,
                      variant: "outline",
                      size: "sm"
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode(" Previous ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayPages.value, (page) => {
                      return (_openBlock(), _createBlock(_unref(Button), {
                        key: page,
                        onClick: ($event: any) => (currentPage.value = page),
                        variant: currentPage.value === page ? 'default' : 'outline',
                        size: "sm",
                        class: "min-w-[40px]"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(page), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "variant"]))
                    }), 128)),
                    _createVNode(_unref(Button), {
                      onClick: nextPage,
                      disabled: currentPage.value === totalPages.value,
                      variant: "outline",
                      size: "sm"
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" Next ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (canSync.value)
      ? (_openBlock(), _createBlock(_unref(Card), {
          key: 0,
          class: "border-green-400 bg-green-100"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CardContent), { class: "pt-6" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_unref(CheckCircle2), { class: "h-8 w-8 text-green-600" }),
                    _createElementVNode("div", null, [
                      _cache[21] || (_cache[21] = _createElementVNode("p", { class: "font-semibold text-green-900" }, "Ready to Sync", -1)),
                      _createElementVNode("p", _hoisted_56, _toDisplayString(stats.value.selectedTariffs) + " tariff code(s) will be synced with " + _toDisplayString(stats.value.selectedMembers) + " member(s) ", 1)
                    ])
                  ]),
                  _createVNode(_unref(Button), {
                    onClick: handleSync,
                    disabled: isSyncing.value,
                    size: "lg",
                    class: "gap-2 border border-green-600"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RefreshCw), {
                        class: _normalizeClass(['h-5 w-5', { 'animate-spin': isSyncing.value }])
                      }, null, 8, ["class"]),
                      _createTextVNode(" " + _toDisplayString(isSyncing.value ? 'Syncing...' : 'Sync Now'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (hasResults.value && isResultDialogOpen.value && _unref(rolloverResults))
        ? (_openBlock(), _createBlock(PreviewResultsDialog, {
            key: 0,
            open: isResultDialogOpen.value,
            "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isResultDialogOpen).value = $event)),
            response: [_unref(rolloverResults)]
          }, null, 8, ["open", "response"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})